export default "__VITE_ASSET__DbyzRBTR__"